<template>
  <pagefra>
    <div
      class="propertyPayable container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            :model="form"
            inline
            class="toolbar-form"
            @submit.native.prevent
          >
            <el-form-item :label="$l('合同号')">
              <el-input
                v-model="form.contractNo"
                :placeholder="$l('合同号')"
                clearable
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('项目名称')">
              <el-input
                v-model="form.projectName"
                :placeholder="$l('项目名称')"
                clearable
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              round
              icon="el-icon-document"
              @click="openStatementDialog"
              v-if="hasPermission('查看账单')"
              >{{ $l("PDF账单") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              align="center"
              width="70"
            ></el-table-column>
            <el-table-column
              :label="$l('合同号')"
              prop="contactNo"
              align="center"
              min-width="180"
            ></el-table-column>
            <el-table-column
              :label="$l('项目名称')"
              prop="projectName"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('客户名称')"
              prop="customerName"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('合同类型')"
              prop="contractType"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯数量')"
              prop="elevatorCount"
              align="center"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :label="$l('应付总金额')"
              prop="totalAmountPayable"
              align="center"
              min-width="110"
            ></el-table-column>
            <el-table-column
              :label="$l('已付总金额')"
              prop="totalAmountPaid"
              align="center"
              min-width="110"
            ></el-table-column>
            <el-table-column
              :label="$l('未付总金额')"
              prop="totalAmountUnPaid"
              align="center"
              min-width="110"
            ></el-table-column>
            <el-table-column
              :label="$l('合同账龄')"
              prop="contractAgingPeriod"
              align="center"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :label="$l('分期明细')"
              align="center"
              width="90"
              fixed="right"
              v-if="hasPermission('查看分期明细')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="openDetailDialog(scope.row)"
                  v-if="hasPermission('查看分期明细')"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('编辑')"
              align="center"
              width="80"
              fixed="right"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  class="table-icon"
                  @click="openEditDialog(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :visible.sync="detailVisible"
        :title="$l('分期明细')"
        width="900px"
        :close-on-click-modal="false"
        custom-class="payable-detail-dialog"
      >
        <el-table
          :data="detailData"
          border
          size="medium"
          style="width: 100%"
          @selection-change="handleDetailSelectionChange"
        >
          <el-table-column
            type="selection"
            align="center"
            width="60"
          ></el-table-column>
          <el-table-column
            :label="$l('期数')"
            prop="installmentCount"
            align="center"
            min-width="80"
          ></el-table-column>
          <el-table-column
            :label="$l('应付金额')"
            prop="amountPayable"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('已付金额')"
            prop="amountPaid"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('未付金额')"
            prop="amountUnPaid"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('账龄')"
            prop="agingPeriod"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            :label="$l('应付款日期')"
            prop="duePaymentDate"
            align="center"
            min-width="130"
          ></el-table-column>
          <el-table-column :label="$l('付款进度')" align="center" width="90">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-time"
                class="table-icon"
                @click="openHistoryDialog(scope.row)"
                v-if="hasPermission('查看付款进度')"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button @click="detailVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="openAddDialog"
            v-if="hasPermission('新增付款进度')"
            >新 增</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="addVisible"
        :title="$l('新增付款进度')"
        width="640px"
        :close-on-click-modal="false"
        custom-class="payable-add-dialog"
      >
        <el-form
          :model="addForm"
          :rules="addRules"
          ref="addForm"
          label-width="110px"
        >
          <el-form-item :label="$l('手机号')" prop="phoneNumber">
            <el-input v-model="addForm.phoneNumber" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$l('单位名称')" prop="companyName">
            <el-input v-model="addForm.companyName" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$l('预计支付时间')" prop="expectedPaymentDate">
            <el-date-picker
              v-model="addForm.expectedPaymentDate"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="addDatePickerOptions"
              :placeholder="$l('请选择日期')"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$l('付款进度说明')"
            prop="paymentProgressDescription"
          >
            <el-input
              v-model="addForm.paymentProgressDescription"
              type="textarea"
              :rows="3"
              :placeholder="$l('请输入付款进度说明')"
              @input="descriptionInput"
            ></el-input>
            <div class="description-count">{{ descriptionCount }}/500</div>
          </el-form-item>
          <el-form-item :label="$l('上传图片附件')" prop="attachments">
            <el-upload
              ref="addUpload"
              multiple
              :limit="9"
              list-type="picture-card"
              action=""
              accept="image/*"
              :http-request="handleAddUpload"
              :on-remove="onAddUploadRemove"
              :on-exceed="onAddUploadExceed"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="addVisible = false">取 消</el-button>
          <el-button
            type="primary"
            :disabled="addUploading > 0"
            @click="submitAdd"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="historyVisible"
        :title="$l('付款进度记录')"
        width="460px"
        :close-on-click-modal="false"
        custom-class="payable-history-dialog"
      >
        <div class="progress-installment">
          <div class="progress-installment__header">
            <div class="progress-installment__col">
              <span class="progress-installment__value">{{
                currentProgressRow.installmentCount
              }}</span>
            </div>
            <div class="progress-installment__col">
              <span class="progress-installment__label"
                >{{ $l("应付款") }}：</span
              >
              <span class="progress-installment__value"
                >￥{{ currentProgressRow.amountPayable }}</span
              >
            </div>
          </div>
          <div class="progress-installment__body">
            <div class="progress-installment__row">
              <div class="progress-installment__col">
                <span class="progress-installment__label"
                  >{{ $l("已付款") }}：</span
                >
                <span class="progress-installment__value"
                  >￥{{ currentProgressRow.amountPaid }}</span
                >
                <span class="progress-installment__percent">{{
                  formatPercent(currentProgressRow.amountPaid)
                }}</span>
              </div>
            </div>
            <div class="progress-installment__row">
              <div class="progress-installment__col">
                <span class="progress-installment__label"
                  >{{ $l("未付款") }}：</span
                >
                <span class="progress-installment__value"
                  >￥{{ currentProgressRow.amountUnPaid }}</span
                >
                <span class="progress-installment__percent">{{
                  formatPercent(currentProgressRow.amountUnPaid)
                }}</span>
              </div>
            </div>
            <div class="progress-installment__row">
              <div class="progress-installment__col">
                <span class="progress-installment__label"
                  >{{ $l("账龄") }}：</span
                >
                <span class="progress-installment__value">{{
                  currentProgressRow.agingPeriod
                }}</span>
              </div>
            </div>
            <div class="progress-installment__row">
              <div class="progress-installment__col">
                <span class="progress-installment__label"
                  >{{ $l("到期支付日") }}：</span
                >
                <span class="progress-installment__value">{{
                  currentProgressRow.duePaymentDate
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-loading.lock="historyLoading" class="progress-list">
          <el-empty
            v-if="historyData.length == 0"
            :description="$l('暂无进度记录')"
          ></el-empty>
          <div
            v-for="(item, index) in historyData"
            :key="item.id"
            class="progress-list__item"
          >
            <div class="progress-list__line">
              <span
                class="progress-list__dot"
                :class="{ last: index == historyData.length - 1 }"
              ></span>
              <span
                v-if="index < historyData.length - 1"
                class="progress-list__bar"
              ></span>
            </div>
            <div class="progress-list__content">
              <div class="progress-list__row">
                <span class="progress-list__value">{{ item.createTime }}</span>
                <span v-if="item.creatorName" class="progress-list__creator"
                  >{{ item.creatorName }} {{ $l("提交") }}</span
                >
              </div>
              <div class="progress-list__body">
                <div class="progress-list__row">
                  <span class="progress-list__label"
                    >{{ $l("预计支付时间") }}：</span
                  >
                  <span class="progress-list__value">{{
                    item.expectedPaymentDate
                  }}</span>
                </div>
                <div class="progress-list__row">
                  <span class="progress-list__label"
                    >{{ $l("进度说明") }}：</span
                  >
                  <span class="progress-list__value">{{
                    item.paymentProgressDescription
                  }}</span>
                </div>
                <div
                  class="progress-list__row"
                  v-if="item.attachments && item.attachments.length"
                >
                  <span class="progress-list__label">{{ $l("附件") }}：</span>
                  <div class="progress-list__attachments">
                    <el-image
                      v-for="(att, i) in item.attachments"
                      :key="i"
                      class="progress-list__img"
                      :src="att.filePath"
                      :preview-src-list="
                        item.attachments.map((a) => a.filePath)
                      "
                      fit="cover"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="editVisible"
        :title="$l('编辑项目名称')"
        width="460px"
        :close-on-click-modal="false"
        custom-class="payable-edit-dialog"
      >
        <el-form
          :model="editForm"
          :rules="editRules"
          ref="editForm"
          label-width="90px"
        >
          <el-form-item :label="$l('项目名称')" prop="projectName">
            <el-input
              v-model="editForm.projectName"
              :placeholder="$l('请输入项目名称')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="statementVisible"
        :title="$l('PDF合同账单')"
        width="1100px"
        :close-on-click-modal="false"
        custom-class="payable-statement-dialog"
      >
        <div class="statement-filter">
          <el-form :model="statementForm" inline @submit.native.prevent>
            <el-form-item>
              <el-select
                v-model="statementForm.status"
                :placeholder="$l('状态')"
                clearable
                style="width: 160px"
              >
                <el-option :value="0" :label="$l('未确认')"></el-option>
                <el-option :value="1" :label="$l('已确认')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="loadStatements"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          :data="statementData"
          border
          size="medium"
          height="400"
          v-loading.lock="statementLoading"
          style="width: 100%"
        >
          <el-table-column
            :label="$l('对账单编号')"
            prop="statementCode"
            align="center"
            min-width="140"
          ></el-table-column>
          <el-table-column
            :label="$l('手机号')"
            prop="phone"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('公司名称')"
            prop="companyName"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('分公司')"
            prop="branchName"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('类型')"
            prop="type"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            :label="$l('对账截止日期')"
            prop="statementEndDate"
            align="center"
            min-width="130"
          ></el-table-column>
          <el-table-column
            :label="$l('数字金额')"
            prop="amount"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('合同号')"
            prop="contractNos"
            align="center"
            min-width="160"
          ></el-table-column>
          <el-table-column
            :label="$l('期数')"
            prop="installmentCount"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column :label="$l('状态')" align="center" min-width="90">
            <template slot-scope="scope">
              <span>{{
                scope.row.status == 1 ? $l("已确认") : $l("未确认")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('是否有疑问')"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.hasQuestion == 1 ? $l("有") : $l("无")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('确认')"
            align="center"
            width="80"
            fixed="right"
            v-if="hasPermission('账单确认')"
          >
            <template slot-scope="scope">
              <i
                v-if="scope.row.status != 1"
                class="el-icon-check statement-icon"
                @click="handleStatementConfirm(scope.row)"
              ></i>
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('疑问')"
            align="center"
            width="80"
            fixed="right"
            v-if="hasPermission('账单疑问')"
          >
            <template slot-scope="scope">
              <i
                v-if="scope.row.status != 1"
                class="el-icon-question statement-icon"
                @click="handleStatementQuestion(scope.row)"
              ></i>
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('下载')"
            align="center"
            width="90"
            fixed="right"
            v-if="hasPermission('下载')"
          >
            <template slot-scope="scope">
              <i
                v-if="scope.row.edocFileId"
                class="el-icon-download statement-icon"
                @click="handleStatementDownload(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="statementPageConfig.currentPage"
          :page-sizes="statementPageConfig.pageSizes"
          :page-size="statementPageConfig.pageSize"
          :total="statementPageConfig.total"
          @size-change="handleStatementPageSizeChange"
          @current-change="handleStatementCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "propertyPayable",
  mixins: [global],
  components: {
    panel,
  },
  data() {
    return {
      form: {
        contractNo: "",
        projectName: "",
      },
      tableData: [],
      loading: false,
      fullLoading: false,
      detailVisible: false,
      detailData: [],
      detailSelection: [],
      currentDetailRow: {},
      addVisible: false,
      addForm: {
        contractNo: "",
        phoneNumber: "",
        companyName: "",
        expectedPaymentDate: "",
        paymentProgressDescription: "",
        attachments: [],
      },
      addRules: {
        phoneNumber: [
          {
            required: true,
            message: this.$l("请输入手机号"),
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: this.$l("请输入单位名称"),
            trigger: "blur",
          },
        ],
        paymentProgressDescription: [
          {
            max: 500,
            message: this.$l("长度不能超过 500 个字符"),
            trigger: "blur",
          },
        ],
      },
      addDatePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      historyVisible: false,
      historyLoading: false,
      historyData: [],
      currentProgressRow: {},
      addUploading: 0,
      editVisible: false,
      editForm: {
        contractNo: "",
        projectName: "",
      },
      editRules: {},
      statementVisible: false,
      statementLoading: false,
      statementData: [],
      statementForm: {
        status: "",
      },
      statementPageConfig: {
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    this.pageConfig.pageChangeCallback = this.loadData;
  },
  mounted() {
    this.loadData();
    this.$nextTick(() => {
      this.$refs.filterTable && this.$refs.filterTable.doLayout();
    });
  },
  computed: {
    descriptionCount() {
      return (this.addForm.paymentProgressDescription || "").replace(
        /(^\s*)|(\s*$)/g,
        ""
      ).length;
    },
  },
  methods: {
    search() {
      this.pageConfig.currentPage = 1;
      this.loadData();
    },
    openDetailDialog(row) {
      this.detailData = row.details || [];
      this.currentDetailRow = row;
      this.detailVisible = true;
    },
    handleDetailSelectionChange(selection) {
      this.detailSelection = selection;
    },
    openHistoryDialog(row) {
      this.currentProgressRow = row;
      this.$http
        .get(this.$apiConfig.get_fd_payable_progress_history_url, {
          params: {
            contractNo: this.currentDetailRow.contactNo,
            installmentNumber: row.installmentCount,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0) {
            const data = result.data || [];
            if (data.length == 0) {
              this.message(-1, "暂无付款进度记录");
              return;
            }
            this.historyData = data;
            this.historyVisible = true;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    formatPercent(val) {
      const total = this.currentDetailRow.totalAmountPayable;
      if (total == null || total === "" || parseFloat(total) == 0) {
        return "";
      }
      const pct = (parseFloat(val || 0) / parseFloat(total)) * 100;
      return "(" + Math.round(pct) + "%)";
    },
    openAddDialog() {
      if (this.detailSelection.length == 0) {
        this.message(-1, "请先勾选期数明细");
        return;
      }
      this.addForm.contractNo = this.currentDetailRow.contactNo || "";
      this.addForm.phoneNumber =
        (this.$store.state.user && this.$store.state.user.telNum) || "";
      this.addForm.companyName = this.currentDetailRow.customerName || "";
      this.addForm.expectedPaymentDate = "";
      this.addForm.paymentProgressDescription = "";
      this.addForm.attachments = [];
      this.addUploading = 0;
      this.$refs.addForm && this.$refs.addForm.clearValidate();
      this.addVisible = true;
      this.$nextTick(() => {
        this.$refs.addUpload && this.$refs.addUpload.clearFiles();
      });
    },
    handleAddUpload(option) {
      const uid = option.file.uid;
      const file = option.file;
      this.addUploading++;
      const formData = new FormData();
      formData.append("file", option.file);
      this.$http
        .post(this.$apiConfig.fd_oss_upload_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.addUploading--;
          const result = response.data;
          if (result.code == 0) {
            const info = result.data || {};
            this.addForm.attachments.push({
              uid,
              filePath: info.url || "",
              fileName: info.originName || file.name || "",
              size:
                info.size != null
                  ? String(info.size)
                  : file.size
                  ? String(file.size)
                  : "",
            });
            option.onSuccess && option.onSuccess(response);
          } else {
            this.message(result.code, result.msg);
            option.onError && option.onError(response);
          }
        })
        .catch((error) => {
          this.addUploading--;
          option.onError && option.onError(error);
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    onAddUploadRemove(file) {
      const idx = this.addForm.attachments.findIndex((x) => x.uid === file.uid);
      if (idx > -1) {
        this.addForm.attachments.splice(idx, 1);
      }
    },
    onAddUploadExceed() {
      this.$message.warning(this.$l("最多只能上传9张图片"));
    },
    descriptionInput(val) {
      const meaningful = val.replace(/(^\s*)|(\s*$)/g, "").length;
      if (meaningful > 500) {
        this.addForm.paymentProgressDescription = val
          .replace(/(^\s*)|(\s*$)/g, "")
          .slice(0, 500);
      }
    },
    submitAdd() {
      if (this.addUploading > 0) {
        this.message(-1, "附件上传中，请稍候");
        return;
      }
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = {
          contractNo: this.addForm.contractNo,
          phoneNumber: this.addForm.phoneNumber,
          companyName: this.addForm.companyName,
          installmentNumbers: this.detailSelection.map(
            (x) => x.installmentCount
          ),
          expectedPaymentDate: this.addForm.expectedPaymentDate,
          paymentProgressDescription: this.addForm.paymentProgressDescription,
          attachments: this.addForm.attachments.map((x) => ({
            filePath: x.filePath,
            fileName: x.fileName,
            size: x.size,
          })),
        };
        this.fullLoading = true;
        this.$http
          .post(this.$apiConfig.add_fd_payable_progress_url, payload)
          .then((response) => {
            this.fullLoading = false;
            const result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.addVisible = false;
              this.loadData();
            }
          })
          .catch((error) => {
            this.fullLoading = false;
            this.errorMessage(1);
            this.$sentry.captureException(error);
          });
      });
    },
    openEditDialog(row) {
      this.editForm.contractNo = row.contactNo;
      this.editForm.projectName = row.projectName || "";
      this.editVisible = true;
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate();
      });
    },
    submitEdit() {
      this.fullLoading = true;
      this.$http
        .post(this.$apiConfig.modify_fd_payable_project_url, {
          contractNo: this.editForm.contractNo,
          projectName: this.editForm.projectName,
        })
        .then((response) => {
          this.fullLoading = false;
          const result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.editVisible = false;
            this.loadData();
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(2);
          this.$sentry.captureException(error);
        });
    },
    openStatementDialog() {
      this.statementVisible = true;
      this.statementPageConfig.currentPage = 1;
      this.statementForm.status = "";
      this.loadStatements();
    },
    loadStatements() {
      this.statementLoading = true;
      this.$http
        .post(this.$apiConfig.get_fd_statement_list_url, {
          page: this.statementPageConfig.currentPage,
          limit: this.statementPageConfig.pageSize,
          status:
            this.statementForm.status === "" ||
            this.statementForm.status == null
              ? undefined
              : this.statementForm.status,
        })
        .then((response) => {
          this.statementLoading = false;
          const result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.statementData = data.records || [];
            this.statementPageConfig.total = data.total || 0;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.statementLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    handleStatementPageSizeChange(val) {
      this.statementPageConfig.currentPage = 1;
      this.statementPageConfig.pageSize = val;
      this.loadStatements();
    },
    handleStatementCurrentPageChange(val) {
      this.statementPageConfig.currentPage = val;
      this.loadStatements();
    },
    handleStatementDownload(row) {
      this.$http
        .get(this.$apiConfig.get_fd_download_url, {
          params: { fileId: row.edocFileId },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0 && result.data) {
            window.open(result.data);
          } else {
            this.message(result.code || -1, result.msg || this.$l("下载失败"));
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    handleStatementConfirm(row) {
      this.$confirm(this.$l("是否提交对账单确认操作？"), this.$l("提示"), {
        confirmButtonText: this.$l("确定"),
        cancelButtonText: this.$l("取消"),
        type: "warning",
      })
        .then(() => {
          this.$http
            .post(this.$apiConfig.fd_statement_confirm_url, { id: row.id })
            .then((response) => {
              const result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.loadStatements();
              }
            })
            .catch((error) => {
              this.errorMessage();
              this.$sentry.captureException(error);
            });
        })
        .catch(() => {});
    },
    handleStatementQuestion(row) {
      this.$confirm(
        this.$l("是否确认提交对账单有疑问操作？"),
        this.$l("提示"),
        {
          confirmButtonText: this.$l("确定"),
          cancelButtonText: this.$l("取消"),
          type: "warning",
        }
      )
        .then(() => {
          this.$http
            .post(this.$apiConfig.fd_statement_question_url, { id: row.id })
            .then((response) => {
              const result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.loadStatements();
              }
            })
            .catch((error) => {
              this.errorMessage();
              this.$sentry.captureException(error);
            });
        })
        .catch(() => {});
    },
    loadData() {
      this.loading = true;
      this.$http
        .post(this.$apiConfig.get_fd_payable_list_url, {
          page: this.pageConfig.currentPage,
          limit: this.pageConfig.pageSize,
          contractNo: this.form.contractNo,
          projectName: this.form.projectName,
        })
        .then((response) => {
          this.loading = false;
          const result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.tableData = data.records || [];
            this.pageConfig.total = data.total || 0;
          } else {
            this.message(result.code, result.msg);
          }
          this.$nextTick(() => {
            this.$refs.filterTable && this.$refs.filterTable.doLayout();
          });
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.propertyPayable {
  /deep/ .statement-filter {
    .el-input__suffix,
    .el-input__prefix {
      display: flex;
      align-items: center;
      top: 0;
      height: 100%;
    }
    .el-input__suffix-inner {
      display: flex;
      align-items: center;
      height: 100%;
    }
    .el-input__suffix .el-input__icon,
    .el-input__prefix .el-input__icon {
      line-height: 1;
    }
  }
  /deep/ .statement-icon {
    font-size: 18px;
    color: #f56c6c;
    cursor: pointer;
  }
  /deep/ .description-count {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1;
    color: #909399;
    text-align: right;
  }
  /deep/ .progress-installment {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    margin-bottom: 16px;
    overflow: hidden;
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      background: linear-gradient(90deg, #eef2f7 0%, #f8fafc 100%);
      border-bottom: 1px solid #e2e8f0;
    }
    &__body {
      padding: 8px 16px;
      & .progress-installment__col {
        flex: 1;
        display: flex;
        align-items: center;
      }
      & .progress-installment__value {
        margin-left: auto;
      }
    }
    &__row {
      display: flex;
      align-items: center;
      line-height: 26px;
    }
    &__label {
      color: #64748b;
      width: 80px;
      flex-shrink: 0;
      white-space: nowrap;
    }
    &__value {
      color: #1f2937;
      font-weight: 600;
    }
    &__percent {
      color: #909399;
      font-size: 12px;
      margin-left: 6px;
    }
  }
  /deep/ .progress-list {
    max-height: 500px;
    overflow-y: auto;
    padding: 4px 8px;
    &__item {
      display: flex;
    }
    &__line {
      position: relative;
      width: 24px;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
    }
    &__dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #c0c4cc;
      margin-top: 5px;
      z-index: 1;
    }
    &__bar {
      position: absolute;
      top: 15px;
      bottom: -15px;
      width: 2px;
      background: #dcdfe6;
    }
    &__content {
      flex: 1;
      padding: 0 8px 28px 8px;
      text-align: left;
    }
    &__body {
      background: #f5f7fa;
      border: 1px solid #ebeef5;
      border-radius: 6px;
      padding: 10px 14px;
      margin-top: 10px;
    }
    &__row {
      line-height: 28px;
      display: flex;
      align-items: flex-start;
    }
    &__label {
      color: #909399;
      flex-shrink: 0;
    }
    &__value {
      color: #303133;
      word-break: break-all;
      flex: 1;
    }
    &__creator {
      color: #606266;
      margin-left: 12px;
    }
    &__attachments {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    &__img {
      width: 80px;
      height: 80px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
    }
  }
}
</style>

<style lang="scss">
.propertyPayable .el-table th .cell,
.propertyPayable .el-table td .cell,
.propertyPayable .el-table__fixed th .cell,
.propertyPayable .el-table__fixed td .cell,
.propertyPayable .el-table__fixed-right th .cell,
.propertyPayable .el-table__fixed-right td .cell {
  text-align: center !important;
}
</style>
